import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AuthState } from './authentication.reducer'

export const selectAuthState = createFeatureSelector<AuthState>('authentication');
export const selectUser = createSelector(selectAuthState, (state) => state.user);
export const selectToken = createSelector(selectAuthState, (state) => state.token);
export const selectIsAuthenticated = createSelector(selectAuthState, (state) => state.isAuthenticated);
export const selectPermissions = createSelector(selectAuthState, (state) => state.permissions);
